import React from 'react'
import { lower } from 'change-case'
import { compose } from 'recompose'
import classnames from 'classnames'
import { Checkbox } from 'semantic-ui-react'

const CheckboxInput = (props) => {
  const { 
    label, 
    input, 
    editable, 
    style, 
    fieldInputStyle, 
    specialOnChange, 
    meta: { touched, error } 
  } = props

  return (
    <div className='fieldRow' style={{...style}}>
      {touched && error ? <span className='error'>{error}</span> : null}
      <div className={classnames('fieldInput', { error: touched && error })} style={fieldInputStyle}>
        <Checkbox  
          {...input}
          checked={
            typeof(input.value) === 'boolean' ? 
              input.value : 
              ((typeof(input.value) === 'string' && lower(input.value)) === 'true' ? true : false)
          }
          label={label}
          disabled={editable === false}
          onChange={(e, { checked }) => {
            input.onChange(checked)
            if (specialOnChange) {
              specialOnChange(checked)
            }
          }} />
      </div>
    </div>
  )
}

export default compose()(CheckboxInput)